/* KIAURA native Buy it now. Replaces Shopify's dynamic checkout button on the product page,
   which is injected by JS after every section render and so blinked out on every colorway swap.
   This one is plain server-rendered markup: nothing to hydrate, nothing to re-mount.

   Same destination as the unbranded dynamic button: checkout with only this item. A cart
   permalink does that without touching the shopper's cart. If the form carries line item
   properties (apps like preorder or personalisation add them), a permalink would drop them,
   so that case adds to cart and goes to /checkout instead. */
(function () {
  if (window.__kiauraBuyNow) return;
  window.__kiauraBuyNow = true;

  function hasProperties(form) {
    var inputs = form.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
      if (el.value) return true;
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kia-buy-now]');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form');
    var idInput = form && form.querySelector('[name="id"]');
    var id = idInput && idInput.value;
    if (!id || btn.disabled) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    if (!hasProperties(form)) {
      window.location.href = '/cart/' + encodeURIComponent(id) + ':' + qty;
      return;
    }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
  });

  /* Visibility is not handled here: data-kia-buy-state on the buy box row (server rendered,
     updated by variant-picker.js) hides this button for sold-out and pre-order sizes in CSS,
     where the notify CTA takes the slot instead. */
})();
